import { IReview } from "interfaces/review.interface";
import { useTranslation } from "react-i18next";
import cls from "./productReviewCard.module.scss";
import StarFillIcon from "remixicon-react/StarFillIcon";
import React from "react";
import dayjs from "dayjs";

type Props = {
  data: IReview;
};

export default function ProductReviewCard({ data }: Props) {
  const { t } = useTranslation();
  return (
    <div className={cls.container}>
      <div className={cls.header}>
        <h4 className={cls.userFullName}>
          {data?.user?.firstname || ""} {data?.user?.lastname || ""}
        </h4>
        <div className={cls.ratingContainer}>
          <StarFillIcon size={18} />
          <span className={cls.rating}>{data?.rating || 0}</span>
        </div>
      </div>
      <div className={cls.datePublished}>
        {t("posted.on")} {dayjs(data?.created_at).format("MMM, DD YYYY")}
      </div>
      <p className={cls.comment}>{data?.comment || t("no.comment")}</p>
    </div>
  );
}
